import { useState, useRef, } from 'react';
import Controls from './Controls.js';
import SliceViewer from './SliceViewer.js';
import Volume3DViewer from './Volume3DViewer.js';
import { OptionsProvider } from './Controls.js';
import { MarkerContextProvider } from './SliceMarker.js';

import './style.css';

export default function App() {
  const contextRef = useRef(null);



  return (
    <div ref={contextRef} className="app-main-center">
      <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
        <OptionsProvider><MarkerContextProvider>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
              <div className="quadrants" style={{ borderColor: 'red', backgroundColor: 'black' }}>
                {<SliceViewer mode="axial" />}
              </div>
              <div className="quadrants quadrant-controls" style={{ borderStyle: 'groove' }}>
                <Controls />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
              <div className="quadrants" style={{ borderColor: 'green', backgroundColor: 'black' }}>
                {<SliceViewer mode="coronal" />}
              </div>
              <div className="quadrants" style={{ borderColor: 'blue', backgroundColor: 'black' }}>
                {<SliceViewer mode="sagittal" />}
              </div>
            </div>
          </div>
        </MarkerContextProvider></OptionsProvider>


        <div>
          <Volume3DViewer/>
        </div>
      </div>
    </div>
  );
}

